module.exports = __webpack_public_path__ + "8ba862d3bfeae1995cb56053260e0273.png";